'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletePost = exports.createPost = exports.fetchPosts = exports.deserializePost = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _oembed = require('constructicon/lib/oembed');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deserializePost = exports.deserializePost = function deserializePost(post) {
  return {
    id: post.id,
    createdAt: post.created_at,
    message: post.caption ? post.caption.split('\n\n').filter(function (item) {
      return !_oembed.videoRegex.test(item.trim());
    }).join('\n\n') : null,
    page: post.page_id,
    image: post.image_url,
    video: post.caption ? (0, _get2.default)(post.caption.match(_oembed.videoRegex), '[0]') : null
  };
};

var fetchPosts = exports.fetchPosts = function fetchPosts() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var mappings = {
    page: 'page_id',
    team: 'team_id',
    type: 'type',
    index: 'page'
  };

  return (0, _client.get)('api/v2/search/feed', _extends({}, params, { type: 'Post' }), { mappings: mappings }).then(function (response) {
    return response.results;
  });
};

var createPost = exports.createPost = function createPost(_ref) {
  var _ref$pageId = _ref.pageId,
      pageId = _ref$pageId === undefined ? (0, _params.required)() : _ref$pageId,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token,
      createdAt = _ref.createdAt,
      image = _ref.image,
      message = _ref.message,
      video = _ref.video;

  var headers = { Authorization: 'Bearer ' + token };

  var data = {
    caption: [message, video].filter(Boolean).join('\n\n'),
    created_at: createdAt,
    image_url: image || null,
    page_id: pageId
  };

  return (0, _client.post)('api/v2/posts', data, { headers: headers }).then(function (data) {
    return data.post;
  });
};

var deletePost = exports.deletePost = function deletePost(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token;
  return (0, _client.destroy)('api/v2/posts/' + id, {
    headers: { Authorization: 'Bearer ' + token }
  });
};